import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39b22b37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "max-w-7xl mx-auto px-2 sm:px-4 lg:px-6" }
const _hoisted_2 = { class: "relative flex items-center justify-between h-16" }
const _hoisted_3 = { class: "absolute inset-y-0 flex items-center sm:hidden" }
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = { class: "flex-1 flex items-center justify-center sm:items-stretch sm:justify-start h-full" }
const _hoisted_6 = { class: "flex-shrink-0 flex items-center ltr:pr-4 rtl:pl-4" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "hidden sm:inline-grid sm:ms-6",
  "data-cy": "navigation-header"
}
const _hoisted_9 = {
  id: "greedy-nav",
  class: "relative flex w-full gap-x-4 overflow-x-hidden whitespace-nowrap"
}
const _hoisted_10 = {
  key: 0,
  id: "more-menu",
  class: "hidden sm:flex items-center w-12 z-10 h-16 hover:bg-primary-400",
  "data-cy": "more-button"
}
const _hoisted_11 = { class: "inline-flex align-middle" }
const _hoisted_12 = { class: "right-menus" }
const _hoisted_13 = { class: "sr-only" }
const _hoisted_14 = { class: "text-opposite-500 text-sm font-medium max-w-xl py-1.5 pr-1 hidden md:block" }
const _hoisted_15 = { class: "block px-4 py-2 text-sm text-gray-700 hover:bg-transparent cursor-default select-none" }
const _hoisted_16 = { class: "font-bold break-words" }
const _hoisted_17 = {
  key: 0,
  class: "text-green-400",
  "data-cy": "access-level-manager"
}
const _hoisted_18 = {
  key: 1,
  class: "text-blue-400",
  "data-cy": "access-level-staff"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-400 mx-4" }, null, -1))
const _hoisted_20 = { class: "px-2 pt-2 pb-3 space-y-1" }
const _hoisted_21 = {
  key: 0,
  class: "pb-4"
}
const _hoisted_22 = {
  key: 1,
  class: "bg-primary-500",
  "data-cy": "small-header"
}
const _hoisted_23 = { class: "max-w-7xl mx-auto px-2 sm:px-4 lg:px-6" }
const _hoisted_24 = { class: "relative flex items-center justify-between h-16" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 flex items-center sm:hidden" }, null, -1))
const _hoisted_26 = { class: "flex-1 flex items-center justify-center sm:items-stretch sm:justify-start h-full" }
const _hoisted_27 = { class: "flex-shrink-0 flex items-center ltr:pr-4 rtl:pl-4" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "right-menus" }
const _hoisted_30 = {
  key: 2,
  class: "bg-primary-500",
  style: {"height":"0.3rem"},
  "data-cy": "tiny-header"
}
const _hoisted_31 = {
  key: 4,
  class: "relative w-full",
  "data-cy": "banner-header"
}
const _hoisted_32 = { class: "absolute w-full bottom-0 bg-gradient-to-r rtl:bg-gradient-to-l from-primary-500 to-transparent" }
const _hoisted_33 = { class: "max-w-7xl mx-auto px-2 sm:px-4 lg:px-6 py-2 text-opposite-500 font-bold text-2xl" }
const _hoisted_34 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuIcon = _resolveComponent("MenuIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DotsHorizontalIcon = _resolveComponent("DotsHorizontalIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_language_dropdown = _resolveComponent("language-dropdown")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!
  const _component_the_strap_line = _resolveComponent("the-strap-line")!
  const _component_content_block = _resolveComponent("content-block")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$store.state.headerType === 'NORMAL')
      ? (_openBlock(), _createBlock(_component_Disclosure, {
          key: 0,
          as: "nav",
          class: "bg-primary-500",
          "data-cy": "normal-header"
        }, {
          default: _withCtx(({ open }) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (
              ((!_ctx.$store.state.user && (_ctx.$store.state.config.features.enableJoinFlow || _ctx.$store.state.config.menu.loginPage)) ||
                _ctx.natigationItems.length) &&
              !_ctx.hideNavbarMenuItems
            )
                    ? (_openBlock(), _createBlock(_component_DisclosureButton, {
                        key: 0,
                        class: "hamburger",
                        "data-cy": "hamburger-button"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('header.openMainMenu')), 1),
                          (!open)
                            ? (_openBlock(), _createBlock(_component_MenuIcon, {
                                key: 0,
                                class: "block h-6 w-6",
                                "aria-hidden": "true"
                              }))
                            : (_openBlock(), _createBlock(_component_XIcon, {
                                key: 1,
                                class: "block h-6 w-6",
                                "aria-hidden": "true"
                              }))
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoHomeUrl())),
                      class: "cursor-pointer"
                    }, [
                      _createElementVNode("img", {
                        class: "h-8 w-auto",
                        src: _ctx.logo,
                        alt: "Logo",
                        "data-cy": "header-logo"
                      }, null, 8, _hoisted_7)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.natigationItems, (item) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          key: item.name,
                          to: item.route,
                          "data-cy": item.cy,
                          class: "text-opposite-500 hover:bg-primary-400 px-3 py-2 text-sm font-medium flex items-center"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(item.name)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "data-cy"]))
                      }), 128))
                    ])
                  ])
                ]),
                (_ctx.more)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_Menu, {
                        as: "div",
                        class: "block relative w-full h-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MenuButton, {
                            class: "text-opposite-500 w-full h-full",
                            "data-cy": "header-more-menu-button"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_DotsHorizontalIcon, { class: "h-6 w-6" })
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition ease-out duration-100",
                            "enter-from-class": "transform opacity-0 scale-95",
                            "enter-to-class": "transform opacity-100 scale-100",
                            "leave-active-class": "transition ease-in duration-75",
                            "leave-from-class": "transform opacity-100 scale-100",
                            "leave-to-class": "transform opacity-0 scale-95"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MenuItems, {
                                id: "more-menu",
                                class: "profile-menu",
                                "data-cy": "more-menu"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.natigationItems, (item, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                      (_ctx.greedyNavigationHiddenItems.has(index))
                                        ? (_openBlock(), _createBlock(_component_MenuItem, {
                                            key: item.name
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(), _createBlock(_component_router_link, {
                                                key: item.name,
                                                to: item.route,
                                                "data-cy": 'more-' + item.cy,
                                                class: "block px-4 py-2 text-sm text-gray-700",
                                                "active-class": "router-link-active-dropdown"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t(item.name)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["to", "data-cy"]))
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 256))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  (!_ctx.$store.state.user && _ctx.$store.state.config.features.enableJoinFlow && !_ctx.hideNavbarMenuItems)
                    ? (_openBlock(), _createBlock(_component_Menu, {
                        key: 0,
                        as: "div",
                        class: "relative sm:block hidden h-full",
                        "data-cy": "navbar-join-menu"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: "/join",
                            "data-cy": "navbar-join-menu-link",
                            class: "text-opposite-500 hover:bg-primary-400 px-3 py-2 text-sm font-medium flex items-center h-full"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('header.register')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.$store.state.user && !_ctx.hideNavbarMenuItems)
                    ? (_openBlock(), _createBlock(_component_Menu, {
                        key: 1,
                        as: "div",
                        class: "relative sm:block hidden h-full",
                        "data-cy": "navbar-login-menu"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.$store.state.config.menu.loginPage)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: "/login",
                                "data-cy": "navbar-login-menu-link",
                                class: "text-opposite-500 hover:bg-primary-400 px-3 py-2 text-sm font-medium flex items-center h-full"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('header.login')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_language_dropdown),
                  (_ctx.$store.state.user)
                    ? (_openBlock(), _createBlock(_component_Menu, {
                        key: 2,
                        as: "div",
                        class: "ml-3 relative",
                        "data-cy": "profile-button"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_MenuButton, {
                              class: "menu-button",
                              "data-cy": "header-profile-menu-button"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('header.openUserMenu')), 1),
                                _createVNode(_component_UserIcon, { class: "h-6 w-6" }),
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('profile.myProfile')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition ease-out duration-100",
                            "enter-from-class": "transform opacity-0 scale-95",
                            "enter-to-class": "transform opacity-100 scale-100",
                            "leave-active-class": "transition ease-in duration-75",
                            "leave-from-class": "transform opacity-100 scale-100",
                            "leave-to-class": "transform opacity-0 scale-95"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MenuItems, {
                                class: "profile-menu",
                                "data-cy": "profile-menu"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_MenuItem, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$store.state.user.firstName) + " " + _toDisplayString(_ctx.$store.state.user.lastName), 1),
                                        (_ctx.$store.state.user.accessLevel.includes('MANAGER'))
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_17, " MANAGER "))
                                          : (_ctx.$store.state.user.accessLevel.includes('STAFF'))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_18, " STAFF "))
                                            : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_19,
                                  (_ctx.$store.state.config.menu.profilePage)
                                    ? (_openBlock(), _createBlock(_component_MenuItem, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_router_link, {
                                            to: "/profile",
                                            class: "block px-4 py-2 text-sm text-gray-700",
                                            "active-class": "router-link-active-dark"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('header.profile')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_MenuItem, { "data-cy": "logout-button" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("a", {
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.signOut())),
                                        class: "block px-4 py-2 text-sm text-gray-700 cursor-pointer"
                                      }, _toDisplayString(_ctx.$t('header.logout')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode(_component_DisclosurePanel, { class: "sm:hidden" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  (!_ctx.$store.state.user)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (_ctx.$store.state.config.features.enableJoinFlow)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: "/join",
                              "data-cy": "hamburger-join-link",
                              class: "hover:bg-primary-400 block px-3 py-2 text-base text-opposite-500 font-medium",
                              "active-class": "router-link-active-hamburger"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DisclosureButton, { class: "w-full text-left" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('header.register')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.$store.state.config.menu.loginPage)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 1,
                              to: "/login",
                              "data-cy": "hamburger-login-link",
                              class: "hover:bg-primary-400 block px-3 py-2 text-base text-opposite-500 font-medium",
                              "active-class": "router-link-active-hamburger"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DisclosureButton, { class: "w-full text-left" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('header.login')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.natigationItems, (item) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: item.name,
                      to: item.route,
                      "data-cy": item.cy,
                      class: "hover:bg-primary-400 block px-3 py-2 text-base text-opposite-500 font-medium",
                      "active-class": "router-link-active-hamburger"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DisclosureButton, { class: "w-full text-left" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(item.name)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["to", "data-cy"]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.$store.state.headerType === 'SMALL')
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("img", {
                    class: "h-8 w-auto",
                    src: _ctx.logo,
                    alt: "Logo",
                    "data-cy": "small-header-logo"
                  }, null, 8, _hoisted_28)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_language_dropdown)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.headerType === 'TINY')
      ? (_openBlock(), _createElementBlock("div", _hoisted_30))
      : _createCommentVNode("", true),
    (_ctx.showStrapLine)
      ? (_openBlock(), _createBlock(_component_the_strap_line, { key: 3 }))
      : _createCommentVNode("", true),
    (_ctx.banner && _ctx.$store.state.headerType !== 'TINY')
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t(_ctx.title)), 1)
          ]),
          _createElementVNode("img", {
            class: "w-full h-72 md:h-80 lg:h-96 object-cover",
            src: _ctx.banner,
            alt: ""
          }, null, 8, _hoisted_34)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.user && _ctx.$store.state.headerType)
      ? (_openBlock(), _createBlock(_component_content_block, { key: 5 }))
      : _createCommentVNode("", true)
  ], 64))
}